/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, TextField, Typography, Tooltip, IconButton, Button, Chip, Collapse, Divider, FormControl, FormControlLabel, FormGroup, FormLabel, FormHelperText, Checkbox, RadioGroup, Radio, Tabs, Tab, 
    CircularProgress, List, ListSubheader, ListItem, ListItemText, InputLabel, Input, Select, MenuItem } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { ExpandLess, ExpandMore, Edit, Delete, Clear } from '@material-ui/icons'

import FlexFormGenerator from '../../../../FlexFormGenerator/FlexFormGenerator';
import Actions from '../../../../../fluid/Actions/ActionFactory'

import { v4 as uuidv4 } from 'uuid';

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);

const AntTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(2),
        padding : theme.spacing(1),
        fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
        color: '#40a9ff',
        opacity: 1,
        },
        '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
        color: '#40a9ff',
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const styles = theme => ({

})


class PreventScreen extends Component {
    state = {
        name : null,
        url : null,
        selected_ic : '',
        selected_ic_object : null,
        wv_fields : [],
        show_app_bar : null,
        show_in_sidebar : null,
        show_form_input : true,
        show_results : true,
        show_settings : true,
        setting_tab_index : 0,
        field_form : []
    }

    componentWillMount () {
        this.generateStateFromConfig()
    }

    componentDidUpdate (prevProps) {
        if (JSON.stringify(prevProps.config) !== JSON.stringify(this.props.config)) {
            this.generateStateFromConfig()
        }
    }

    generatePath = (name) => {
        if (name !== null) {
            let path = name.toLowerCase()
            path = path.replace(/ /g,"_")
            path = '/' + path
            return path
        } else {
            return '/_'
        }
    }

    generateFieldStringURL = () => {
        let field_strings = ""
        this.state.wv_fields.map((field, i) => {
            if (i === this.state.wv_fields.length -1) {
                field_strings = field_strings + field.name + "=[Add Search Text Here]"
            } else {
                field_strings = field_strings + field.name + "=[Add Search Text Here]&"
            }
        })
        return field_strings
    }

    generateDeeplink = (name) => {
        let url = this.generatePath(name)
        let deep_link = url + "?" +  (this.state.show_app_bar ? "" : "showAppbar=false&") + this.generateFieldStringURL()
        return deep_link
    }

    generateStateFromConfig = () => {
        this.setState({
            ...this.state,
            name : this.props.config.name,
            url : this.props.config.route,
            selected_ic : this.props.config.default_params.ic_name ? this.props.config.default_params.ic_name  : '',
            selected_ic_object : this.props.config.default_params.ic_name ? this.props.ic_list.find(ic => ic.name === this.props.config.default_params.ic_name) : null,
            wv_fields : this.props.config.default_params.wv_fields ? this.props.config.default_params.wv_fields  : [],
            show_app_bar : this.props.config.default_params.showAppbar !== undefined ? this.props.config.default_params.showAppbar : true,
            show_in_sidebar : this.props.config.show_in_sidebar !== undefined ? this.props.config.show_in_sidebar : true,
            show_form_input : this.props.config.default_params.show_form_input !== undefined ? this.props.config.default_params.show_form_input : true,
            show_results : this.props.config.default_params.show_results !== undefined ? this.props.config.default_params.show_results : true,
            show_settings : this.props.editing_id === this.props.config.id ? true : false,
            field_form : this.props.config.default_params.field_form !== undefined ? this.props.config.default_params.field_form : [],
        })
    }

    generateConfigFromState = () => {
        let config = this.props.config
        config.name = this.state.name
        config.route = this.generatePath(this.state.name)
        config.show_in_sidebar = this.state.show_in_sidebar
        config.default_params.ic_name = this.state.selected_ic
        config.default_params.showAppbar = this.state.show_app_bar
        config.default_params.show_form_input = this.state.show_form_input
        config.default_params.show_results = this.state.show_results
        config.default_params.wv_fields = this.state.wv_fields
        config.default_params.field_form = this.state.field_form
        console.log("Generating Case Config : ", config)

        return config
    }

    isValid = () => {
        if (this.state.name !== null && this.state.selected_ic !==  '') {
            return true
        } else {
            return false
        }
    }

    updateState = (state_key, value) => {
        this.setState({ ...this.state, [state_key] : value })
    }

    renderName = (edit) => {
        if (edit) {
            return (
                <div style = {{width : '25%', flexGrow: 1, margin : '5px', borderRadius : '5px', padding : '5px'}}>
                    <TextField
                        style = {{width : '100%'}}
                        label = "Name"
                        value = {this.state.name}
                        onChange = {(event) => {
                            if (event.target.value !== "") {
                                this.updateState('name', event.target.value)
                            } else {
                                this.updateState('name', null)
                            }
                        }}
                        variant = 'filled'
                        size = 'small'
                    />
                </div>
            )
        } else {
            return (
                <div style = {{width : '25%', flexGrow: 1, margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                    <Typography variant = 'subtitle2' color = 'primary'>Name</Typography>
                    <Typography variant = 'body2'>{this.props.config.name}</Typography>
                </div>
            )
        }
    }

    renderICList = (edit) => {
        return (
            <div style = {{width : '50%',margin : '5px', borderRadius : '5px', padding : '5px'}}>
                    <Autocomplete
                        id="tags-standard"
                        options={this.props.ic_list.map(ic_obj => ic_obj.name)}
                        value = {this.state.selected_ic}
                        onChange = {(event, newValue) => {
                            let selected_ic_object = this.props.ic_list.find(ic => ic.name === newValue)
                            let wv_fields = selected_ic_object.world_view.fields.map(field => {
                                return {
                                    name : field.name,
                                    required : false
                                }
                            })
                            this.setState({...this.state, selected_ic : newValue, selected_ic_object : selected_ic_object, wv_fields : wv_fields, setting_tab_index : 0}, () => console.log('Prevent :: WV Fields : ', this.state.wv_fields))
                        }}
                        disabled = {!edit}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                                label="Information Channel"
                                variant = 'filled'
                                size = 'small'
                            />
                        )}
                    />
                </div>
        )
    }

    renderActions = (edit) => {
        if (!edit) {
            return (
                <div style = {{margin : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-around'}}>
                    <Tooltip title = 'Delete'>
                        <IconButton color = 'secondary' onClick = {() => this.props.delete(this.props.config)}>
                            <Delete fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title = 'Edit' >
                        <IconButton onClick = {() => {
                            this.setState({...this.state, show_settings : true}, () => {
                                this.props.enable_edit(this.props.config)
                            })
                        }}>
                            <Edit fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    }

    renderScreenSettings = (edit) => {
        return (
            <div style = {{width : '100%', padding : '5px'}}>
                    <Typography style = {{display : 'block'}} variant = 'subtitle2'>Settings</Typography>
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', padding : '5px', flexWrap : 'wrap'}}>
                        <div style = {{width : '25%'}}>
                            <FormControlLabel
                                disabled = {!edit}
                                control={
                                    <Checkbox
                                      checked={this.state.show_app_bar}
                                      onChange={(event) => this.updateState("show_app_bar", event.target.checked)}
                                      name="show_app_bar"
                                      color="primary"
                                    />
                                  }
                                label="Show Application Bar"
                            />
                        </div>
                        <div style = {{width : '25%'}}>
                            <FormControlLabel
                                disabled = {!edit}
                                control={
                                    <Checkbox
                                      checked={this.state.show_in_sidebar}
                                      onChange={(event) => this.updateState("show_in_sidebar", event.target.checked)}
                                      name="show_in_sidebar"
                                      color="primary"
                                    />
                                  }
                                label="Show link in the sidebar menu"
                            />
                        </div>
                        <div style = {{width : '25%'}}>
                            <FormControlLabel
                                disabled = {!edit}
                                control={
                                    <Checkbox
                                      checked={this.state.show_form_input}
                                      onChange={(event) => this.updateState("show_form_input", event.target.checked)}
                                      name="show_form_input"
                                      color="primary"
                                    />
                                  }
                                label="Show the test record form"
                            />
                        </div>
                        <div style = {{width : '25%'}}>
                            <FormControlLabel
                                disabled = {!edit}
                                control={
                                    <Checkbox
                                      checked={this.state.show_results}
                                      onChange={(event) => this.updateState("show_results", event.target.checked)}
                                      name="show_results"
                                      color="primary"
                                    />
                                  }
                                label="Show duplcate results"
                            />
                        </div>
                    </div>
                </div>
        )
    }

    toggleMandatory = (name) => {
        let wv_field_index = this.state.wv_fields.findIndex(wv_field => wv_field.name === name)
        let wv_fields = [...this.state.wv_fields]
        wv_fields[wv_field_index].required = !wv_fields[wv_field_index].required
        this.setState({...this.state, wv_fields : wv_fields})
    }

    getFieldSettingsError = () => {
        if (this.state.selected_ic === "") {
            return [true, "Select an IC to view the WV Fields"]
        } else {
            return [false, '']
        }
    }

    renderFieldSettings = (edit) => {
        return (
            <div style = {{padding : '10px', height : '50vh'}}>
                <FormControl required error = {this.getFieldSettingsError()[0]}  component="fieldset">
                    <FormLabel component="legend">Select Mandatory World View Fields</FormLabel>
                        <FormGroup>
                            {this.state.wv_fields.map(wv_field => {
                                return (
                                    <FormControlLabel
                                        disabled = {!edit}
                                        control={<Checkbox checked={wv_field.required} onChange={() => this.toggleMandatory(wv_field.name)} name={wv_field.name} />}
                                        label={wv_field.name}
                                    />
                                )
                            })}
                        </FormGroup>
                    <FormHelperText>{this.getFieldSettingsError()[1]}</FormHelperText>
                </FormControl>
            </div>
        )
    }

    updateForm = (form) => {
        this.setState({...this.state, field_form : form}, () => console.log('Prevent :: Field Form Updated : ', this.state.field_form))
    }

    renderFieldForm = (edit) => {
        return (
            <div style = {{height : '50vh', width : '100%'}}>
                <FlexFormGenerator 
                    config = {this.state.field_form} 
                    heading = "Create test record form" 
                    binding_keys = {this.state.wv_fields} 
                    updateParent = {(form) => {this.updateForm(form)}}
                />
            </div>
        )
    }

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
    }

    renderDeeplinks = () => {
        return (
            <div style = {{width : '100%', padding : '5px'}}>
                <Typography style = {{display : 'block'}} variant = 'subtitle2'>Deeplinks</Typography>
                <Divider/>
                <div style = {{margin : '5px', padding : '10px', width : '100%', display : 'flex', flexDirection : 'row'}}>
                    <div>
                        <Typography variant = 'body2' color = 'primary'>Deeplink to this screen<em>(Append Search String in the end)</em></Typography>
                        <Tooltip title = 'Click to copy'>
                            <Typography 
                                onClick = {(event) => this.copyToClipboard(window.location.origin + '/#' + this.generateDeeplink(this.state.name))} 
                                style = {{cursor : 'pointer'}} 
                                variant = 'body2'
                            >
                                {window.location.origin + '/#' + this.generateDeeplink(this.state.name)}
                            </Typography>
                        </Tooltip>
                    </div>
                </div>
            </div>
        )
    }

    renderTabContent = (edit) => {
        switch (this.state.setting_tab_index) {
            case 0:
                return this.renderScreenSettings(edit)
            case 1:
                return this.renderFieldSettings(edit)
            case 2:
                return this.renderFieldForm(edit)
            case 3:
                return this.renderDeeplinks(edit)
            default:
                return null
        }
    }

    handleTabChange = (event, newValue) => {
        this.setState({...this.state, setting_tab_index : newValue})
    }

    renderSettings = (edit) => {
        return (
            <div style = {{width : '100%'}}>
                <AntTabs
                    value={this.state.setting_tab_index}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleTabChange}
                    aria-label="Display Config Tabs"
                >
                    <AntTab label="Settings" disabled = {!this.isValid()}/>
                    <AntTab label="Field Settings" disabled = {!this.isValid()}/>
                    <AntTab label="Record Form" disabled = {!this.isValid()}/>
                    <AntTab label="Deeplinks" disabled = {!this.isValid()}/>
                </AntTabs>
                {this.renderTabContent(edit)}
            </div>
        )
    }

    renderPreventScreen = (edit) => {
        return (
            <Paper style = {{width : '100%', marginTop : '10px'}}>
                <div style = {{width : '100%', padding: '10px', display : 'flex', flexDirection : 'row', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <div style = {{margin : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                        <Tooltip title = 'Show Settings' >
                            <IconButton onClick = {() => this.updateState('show_settings', !this.state.show_settings)}>
                                {this.state.show_settings ? <ExpandLess fontSize = 'small'/> : <ExpandMore fontSize = 'small'/>}
                            </IconButton>
                        </Tooltip>
                    </div>
                    {this.renderName(edit)}
                    {this.renderICList(edit)}
                    {this.renderActions(edit)}
                </div>
                <Collapse in = {this.state.show_settings}>
                    {this.renderSettings(edit)}
                </Collapse>
                {this.renderSubmit(edit)}
            </Paper>
        )
    }

    renderSubmit = (edit) => {
        if (edit) {
            return (
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row-reverse', padding : '5px', borderTop: '1px solid rgba(0,0,0,0.12)'}}>
                    <Button
                        disabled = {!this.isValid()}
                        variant = "contained"
                        color = 'primary'
                        size = 'small'
                        onClick = {() => {
                            this.setState({...this.state, show_settings : false}, () => {
                                this.props.update(this.generateConfigFromState())
                            })
                        }}
                    >Submit</Button>
                    <Button
                        style = {{marginRight : '5px'}}
                        variant = "contained"
                        color = 'secondary'
                        size = 'small'
                        onClick = {() => {
                            if (this.state.name === null) {
                                this.setState({...this.state, show_settings : false}, () => {
                                    this.props.delete(this.props.config)
                                })
                            } else {
                                this.setState({...this.state, show_settings : false}, () => {
                                    this.generateStateFromConfig()
                                    this.props.update(this.props.config)
                                })
                            }
                        }}
                    >Cancel</Button>
                </div>
            )
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderPreventScreen(this.props.editing_id === this.props.config.id ? true : false)}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(PreventScreen);